import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { langFromPath } from "../lib/langRoutes";

/**
 * Syncs i18n.language with the current URL prefix (/pt, /en, or DE default).
 * Renders nothing.
 */
export const LangSync = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = langFromPath(pathname);
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [pathname, i18n]);

  return null;
};
